var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionMeh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2321,
    cy: 23.2321,
    r: 22.2321,
    fill: "#F85A17",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.536 22.1059C35.536 29.1666 29.8121 34.8904 22.7514 34.8904C15.6906 34.8904 9.9668 29.1666 9.9668 22.1059C9.9668 15.0451 15.6906 9.32129 22.7514 9.32129C29.8121 9.32129 35.536 15.0451 35.536 22.1059Z",
    fill: "url(#paint0_linear_392_16922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8128 24.9545C30.9788 24.3288 30.7022 24.8142 31.3279 24.9801L31.5363 25.0354C34.1004 25.7155 35.6262 28.3482 34.9454 30.9152C34.2645 33.4823 31.6345 35.0128 29.0704 34.3327L26.9598 33.773C26.3342 33.607 25.9615 32.9653 26.1274 32.3396C26.1887 32.1086 26.3148 31.9121 26.4811 31.7644L26.371 31.7352C25.7454 31.5693 25.5435 30.9729 25.7095 30.3472C25.7734 30.1064 25.9077 29.9031 26.0845 29.7535C25.5952 29.5114 25.3272 28.951 25.4726 28.4028C25.5569 28.0849 25.8523 27.9055 25.8699 27.8392C23.2382 27.1413 23.4538 27.1984 23.1487 26.5759C23.0769 26.3647 23.0644 26.1307 23.1259 25.8989C23.2918 25.2732 23.9335 24.9006 24.5592 25.0665L32.4971 27.1718C32.4259 26.9612 30.7516 25.1855 30.8128 24.9545Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9175 27.2932L33.9762 27.3087C33.9817 27.363 34.0255 27.464 34.0871 27.6063C34.3243 28.1543 34.8269 29.3152 34.438 30.7811C33.8313 33.0684 31.4884 34.4309 29.2055 33.8255L27.0923 33.265C26.7471 33.1734 26.5415 32.8194 26.633 32.4742C26.7245 32.1292 27.0788 31.9238 27.4238 32.0149L27.4213 32.0142L27.5559 31.5064L26.677 31.2733C26.3318 31.1817 26.1262 30.8277 26.2177 30.4825C26.3092 30.1376 26.6628 29.932 27.0077 30.023L27.1432 29.5154L26.4401 29.3289C26.0949 29.2373 25.8893 28.8833 25.9808 28.5381C26.0724 28.1929 26.4264 27.9873 26.7716 28.0788L27.6506 28.312L27.7853 27.8041L24.0934 26.825C23.7482 26.7334 23.5426 26.3793 23.6341 26.0342C23.7257 25.689 24.0797 25.4833 24.4249 25.5749L28.1165 26.554L32.2046 27.6382L32.3585 27.0578L30.6236 25.6628C30.3502 25.433 30.3148 25.0251 30.5445 24.7517C30.7742 24.4783 31.1821 24.4429 31.4555 24.6726L32.727 25.6684C33.2197 26.0824 33.624 26.6306 33.9175 27.2932Z",
    fill: "url(#paint1_linear_392_16922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6189 27.5779C34.3803 26.8457 33.9896 26.0581 33.1782 25.351L31.7917 24.2698C31.2961 23.8534 30.5568 23.9176 30.1404 24.4132C29.9866 24.5962 29.8984 24.8124 29.8732 25.0333L29.8682 25.0291C29.8259 25.4057 29.9669 25.7957 30.2788 26.0577L32.0432 27.4651L32.2292 27.6326L32.3799 27.0643L30.6218 25.6622C30.3483 25.4325 30.3129 25.0246 30.5426 24.7512C30.7724 24.4778 31.1803 24.4423 31.4537 24.6721L32.8402 25.7533C33.4534 26.4128 33.4534 26.4128 34.012 27.4972L34.6189 27.5779Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1055 24.4561L28.1671 22.5003",
    stroke: "black",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6988 17.9893C18.8433 18.7327 18.5587 19.4134 18.0631 19.5097C17.5676 19.606 17.0487 19.0815 16.9042 18.3382C16.7597 17.5948 17.0443 16.9141 17.5399 16.8178C18.0355 16.7214 18.5543 17.246 18.6988 17.9893Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9652 15.0682C23.9652 15.0682 24.799 14.5869 25.1101 14.4073C25.6825 14.0768 26.134 14.1977 26.134 14.1977",
    stroke: "#262626",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8254 15.1473C15.8254 15.1473 16.0086 14.695 16.6442 14.4257C17.2798 14.1564 17.7322 14.3396 17.7322 14.3396",
    stroke: "#262626",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5875 16.3506C26.732 17.094 26.4474 17.7747 25.9518 17.871C25.4562 17.9674 24.9374 17.4428 24.7929 16.6995C24.6484 15.9561 24.933 15.2754 25.4286 15.1791C25.9241 15.0828 26.443 15.6073 26.5875 16.3506Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_392_16922",
    x1: 9.9668,
    y1: 9.32129,
    x2: 36.6396,
    y2: 10.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_392_16922",
    x1: 27.8496,
    y1: 21.2598,
    x2: 36.4739,
    y2: 29.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionMeh);
export default __webpack_public_path__ + "static/media/reaction_meh.d0f367c4109541d23bc889ec836f2a36.svg";
export { ForwardRef as ReactComponent };